module.exports = __webpack_public_path__ + "static/media/15-06.2edc2f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/videos/15-06.png
// module id = 127
// module chunks = 0